import { isValue } from '../../service/helpers';
import { GTM_QUIZ_NAME } from '../../service/variables';
import { QuizValues } from '../../store/quiz/types';
import { Question } from '../../types/question';

class GoogleAnalytics {
  static sendEvent = (eventCategory: string, eventAction: string, eventLabel: string): void => {
    if (typeof window === 'undefined' || typeof window['ga'] === 'undefined') {
      return;
    }

    window['ga']('send', 'event', {
      eventCategory: `${eventCategory}`,
      eventAction: `${eventAction}`,
      eventLabel: `${eventLabel}`,
    });

    return;
  };

  static sendLookbookId = (id: string): void => {
    if (typeof window === 'undefined' || typeof window['dataLayer'] === 'undefined') {
      return;
    }

    window['dataLayer'].push({ lookbookId: id });

    return;
  };

  static sendAnswers({ values, currentQuestions }: { values: QuizValues; currentQuestions: Question[] }) {
    if (currentQuestions.length === 0) {
      return;
    }
    const eventLabel = (data: QuizValues): string => {
      if (!isValue(data, currentQuestions[0].name)) {
        return 'no value';
      }
      const result = data[currentQuestions[0].name];

      if (Array.isArray(result)) {
        const options = currentQuestions[0].options.filter((el) => result.includes(el.id));
        return options.map((el) => (el.tags[0]?.name || '').toLowerCase()).join(',');
      } else {
        return result.toString();
      }
    };
    this.sendEvent(GTM_QUIZ_NAME, 'continue', eventLabel(values));
  }
}

export default GoogleAnalytics;
